import { useParams } from 'react-router-dom';

import InviteStudentsView from './InviteStudents';
import InviteStudentsContainer from './InviteStudentsContainer';
import { RosterProvider } from '../../context/RosterContext';

const InviteStudents = () => {
    const { classUuid } = useParams<{ classUuid: string }>();

    const userUuid = window.localStorage.getItem('user_uuid');

    const search = new URLSearchParams(window.location.search);
    const isDemo = search.get('isDemo');
    const classId = search.get('class_id');

    return (
        <InviteStudentsContainer.Provider>
            <RosterProvider classId={classId} classUuid={classUuid} userUuid={userUuid} isDemo={isDemo}>
                <InviteStudentsView />
            </RosterProvider>
        </InviteStudentsContainer.Provider>
    );
};

export default InviteStudents;
